<template>
    <div class="wrapper">
        <TopNav v-if="authenticated && user" :user="user"></TopNav>
        <div class="content-wrapper">
            <div class="container-fluid">
                <router-view></router-view>
            </div>
        </div>

        <footer class="main-footer d-print-none text-center">
            <strong>Copyright &copy; <a href="https://www.hopesoftbd.com" class="text-decoration-none" target="_blank">HopeSoft</a> </strong> All rights reserved. Cell: 016 8082 4484 |
            <span class="hidden-xs"><b>Version:</b> 26.8</span>
        </footer>
    </div>
</template>

<script setup>
import moment from "moment";

import eventHub from "../bus";

import TopNav from "./Nav/TopNav.vue";
import { useAuthStore } from "@/store/auth";
import { onMounted, watch } from "vue";
import { storeToRefs } from "pinia";

const auth = useAuthStore();

const { user, authenticated } = storeToRefs(auth);
</script>

<style lang="scss" scoped>
.items {
    display: flex;
    justify-content: space-around;
}
</style>
